import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SalaryDividendFormFactory } from './salary-dividend-form.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CalculationStore } from '../../../../../stores/calculation.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { CalculationBaseForm } from '../../../base-form/form/base-form/calculation-base.form';
import { CalculationsUtils } from '../../../../../utils/calculations.utils';
import { AlertMessageStore } from '../../../../../../core/stores/alert-message.store';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import {
  CalculationKeynameEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { Subscription } from 'rxjs';
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { ImportManager } from '../../../../../managers/import.manager';
import { FormChangeManager } from '../../../../../managers/form-change.manager';
import { CalculationLifecycleManager } from '../../../../../managers/calculation-lifecycle.manager';
import { ValidationGroupEnum } from '../../../../../../../../../../../common/src/enums/validation-group.enum';
import { EventManager } from '../../../../../../core/managers/event.manager';
import {
  QppPensionOptionsInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/qpp-pension/qpp-pension-options-in-salary-dividend.options';
import {
  CorporateIncomeTaxInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-in-salary-dividend.options';
import {
  IncomeTaxPersonalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';
import {
    CorporateIncomeTaxFederalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-federal-in-salary-dividend.options';
import { DebugUtils } from '../../../../../../core/utils/debug.utils';


@Component({
  selector: 'app-salary-dividend-form',
  templateUrl: './salary-dividend-form.component.html',
  styleUrls: ['./salary-dividend-form.component.scss'],
  standalone: false,
})
export class SalaryDividendFormComponent extends CalculationBaseForm<SalaryDividendOptions> implements OnInit, OnDestroy {

  calculationKeynameEnum = CalculationKeynameEnum;

  isExecuteButtonEnabled: boolean = false;

  onApplicabilityChangeSubscription: Subscription;

  constructor(public override readonly formFactory: SalaryDividendFormFactory,
              public readonly debugUtils: DebugUtils,
              calculationStore: CalculationStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef,
              importManager: ImportManager,
              calculationLifecycleManager: CalculationLifecycleManager,
              formChangeManager: FormChangeManager,
              eventManager: EventManager,
  ) {
    super(
      formFactory,
      calculationStore,
      translateService,
      activatedRoute,
      modalService,
      router,
      optionsMapper,
      calculationsUtils,
      alertMessageStore,
      CalculationKeynameEnum.SalaryDividendSimulation,
      importManager,
      calculationLifecycleManager,
      formChangeManager,
      eventManager,
      [ValidationGroupEnum.SalaryDividend],
    );
    this.optionsType = SalaryDividendOptions;
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  // postUpdateCallback() {
  //     const spouses = this.form.formElements.spouses as AdvancedFormArray<SalaryDividendPersonalSpouseOptions>;
  //     if(spouses.length === 0){
  //         spouses.appendNew();
  //     }
  //     this.changeDetectorRef.detectChanges();
  // }

  get personalIncomeForm(): AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions> {
    return this.form.formElements.incomeTaxPersonalOptions as AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions>;
  }

  get corporateTaxForm(): AdvancedFormGroup<CorporateIncomeTaxInSalaryDividendOptions> {
    return this.form.formElements.corporateIncomeTaxOptions as AdvancedFormGroup<CorporateIncomeTaxInSalaryDividendOptions>;
  }

    get qppPensionForm(): AdvancedFormGroup<QppPensionOptionsInSalaryDividendOptions> {
        return this.form.formElements.qppPensionOptions as AdvancedFormGroup<QppPensionOptionsInSalaryDividendOptions>;
    }

    get corporateFederalTaxForm(): AdvancedFormGroup<CorporateIncomeTaxFederalInSalaryDividendOptions> {
        return this.corporateTaxForm.formElements.incomeTaxCorporationFederal as AdvancedFormGroup<CorporateIncomeTaxFederalInSalaryDividendOptions>;
    }


  override ngOnInit(): void {
    super.ngOnInit();

  }

  override ngOnDestroy() {
    super.ngOnDestroy();

  }

  override refresh() {
  }
}
